/**
 * Common Page
 * @class Common
 */

import Header from '../modules/header.js';
import SmoothScroll from '../modules/smoothscroll.js';
import Accordion from '../modules/accordion.js';
import Modal from '../modules/modal.js';

export default class Common {

  constructor() {
    this.init();
  }

  init() {
    new Header();
    new SmoothScroll();
    new Accordion();
    new Modal();
    this.resize();
  }

  resize() {
    const mediaQueryList = window.matchMedia('(max-width: 320px)');
    const listener = (event) => {
      // リサイズ時に行う処理
      if (event.matches) {
        document.querySelector("meta[name='viewport']").setAttribute("content", "width=320");

      } else {
       document.querySelector("meta[name='viewport']").setAttribute("content", "width=device-width,initial-scale=1.0,viewport-fit=cover");
      }
    };

    // リスナー登録
    // mediaQueryList.addListener(listener); // @deprecated
    mediaQueryList.addEventListener("change", listener);

    // 初期化処理
    listener(mediaQueryList);
  }


}
